var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-scroller",class:_vm.scrollClasses,on:{"&scroll":function($event){return _vm.$emit('scroll', $event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }